import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import KvkkForm, { applyKvkkLocalizableChanges, KvkkLocalizableChanges } from "../../components/KvkkForm";
import { useKvkkContext } from "../../context/KvkkContext/KvkkContext";
import { KVKK_LIST_PATH, KvkkGeneralFormData } from "../../context/KvkkContext/constants";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const EditKvkk = () => {
	const { id } = useParams<{ id: string }>();
	const { updateKvkk, getKvkkDetails, clearKvkkFormData, kvkkEditForm, setKvkkEditForm, operationStatus } = useKvkkContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getKvkkDetails(id);
		}

		return () => {
			clearKvkkFormData();
		};
	}, [id, getKvkkDetails, clearKvkkFormData]);

	const handleGeneralChange = useCallback((changes: Partial<KvkkGeneralFormData>) => {
		setKvkkEditForm(prev => (prev ? { ...prev, ...changes } : null));
	}, [setKvkkEditForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: KvkkLocalizableChanges) => {
		setKvkkEditForm(prev => (prev ? {
			...prev,
			kvkkTextLocalizable: applyKvkkLocalizableChanges(prev.kvkkTextLocalizable, culture, changes),
		} : null));
	}, [setKvkkEditForm]);

	return (
		<>
			<BackComponent text="KVKK Metinleri Listesine Dön" to={KVKK_LIST_PATH} />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>KVKK Metni Güncelleme</FormHeaderComponent>
						{kvkkEditForm && (
							<KvkkForm
								key={kvkkEditForm.kvkkTextId}
								general={kvkkEditForm}
								localizables={kvkkEditForm.kvkkTextLocalizable}
								isRequired={false}
								onGeneralChange={handleGeneralChange}
								onLocalizableChange={handleLocalizableChange}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateKvkk}
								type="default"
								disabled={!kvkkEditForm}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default EditKvkk;
